import React, { FunctionComponent, ReactElement } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Checkbox from "@Components/atoms/Checkbox";
import "./style.scss";

interface Props {
  checked: boolean;
  onCheck: () => void;
}

const CartCGU: FunctionComponent<Props> = ({ checked, onCheck }): ReactElement => {
  const intl = useIntl();
  const CGUlink = `https://www.cheerz.com/${intl.locale}/pages/terms-and-conditions`;

  return (
    <div className="CartCGU">
      <div className="CartCGU-checkboxWrapper">
        <Checkbox checked={checked} onChange={onCheck} type="square" />
        <div className="CartCGU-checkboxText" onClick={onCheck}>
          <FormattedMessage id={"cheerz_CartCGU_text"} />
          <a href={CGUlink} target="_blank" rel="noopener noreferrer">
            <FormattedMessage id={"cheerz_CartCGU_link"} />
          </a>
        </div>
      </div>

      <div className="CartCGU-info">
        <FormattedMessage id={"cheerz_CartCGU_info"} />
      </div>
    </div>
  );
};

export default CartCGU;
